import { gql } from '@urql/core';

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout {
      success
    }
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      id
      identifier
      channels {
        id
        code
        token
        permissions
      }
    }
  }
`;

export const GET_TWO_FACTOR_STATUS = gql`
  query GetTwoFactorStatus {
    twoFactorStatus {
      enabled
      backupCodesRemaining
    }
  }
`;

export const SETUP_TWO_FACTOR = gql`
  mutation SetupTwoFactor {
    setupTwoFactor {
      manualEntryKey
      otpAuthUri
      qrCodeDataUrl
    }
  }
`;

export const VERIFY_TWO_FACTOR_SETUP = gql`
  mutation VerifyTwoFactorSetup($code: String!) {
    verifyTwoFactorSetup(code: $code) {
      success
      backupCodes
    }
  }
`;

export const VERIFY_TWO_FACTOR_LOGIN = gql`
  mutation VerifyTwoFactorLogin($twoFactorToken: String!, $code: String!, $isBackupCode: Boolean) {
    verifyTwoFactorLogin(twoFactorToken: $twoFactorToken, code: $code, isBackupCode: $isBackupCode) {
      success
      error
      errorCode
      attemptsRemaining
      backupCodesRemaining
      token
      user {
        id
        identifier
        verified
      }
      defaultChannel {
        id
        code
        name
      }
      channels {
        id
        code
        name
        role
        token
        defaultCurrencyCode
      }
    }
  }
`;

export const DISABLE_TWO_FACTOR = gql`
  mutation DisableTwoFactor($password: String!) {
    disableTwoFactor(password: $password) {
      success
      message
      errorCode
    }
  }
`;

export const REGENERATE_BACKUP_CODES = gql`
  mutation RegenerateBackupCodes($code: String!) {
    regenerateBackupCodes(code: $code) {
      success
      backupCodes
      errorCode
      attemptsRemaining
    }
  }
`;

export const ADMIN_LOGIN = gql`
  mutation AdminLogin($username: String!, $password: String!) {
    adminLogin(username: $username, password: $password) {
      success
      token
      twoFactorRequired
      twoFactorToken
      errorCode
      user {
        id
        identifier
        verified
      }
      defaultChannel {
        id
        code
        name
      }
      channels {
        id
        code
        name
        role
        token
        defaultCurrencyCode
      }
    }
  }
`;

export const REFRESH_ADMIN_TOKEN = gql`
  mutation RefreshAdminToken {
    refreshAdminToken {
      success
      token
      expiresIn
      errorCode
    }
  }
`;

export const SWITCH_CHANNEL = gql`
  mutation SwitchChannel($channelId: Int!) {
    switchChannel(channelId: $channelId) {
      success
      token
      channel {
        id
        code
        name
      }
      message
    }
  }
`;
